// Send referrer to requesting iframes


window.addEventListener('message', function(event) {
    if(event.data && event.data.action == 'ga4_player_event') {

        console.log('[playerEventsToDataLayer] caught ga4_player_event', event.data);

        if(event.data.hasOwnProperty('eventName') && event.data.hasOwnProperty('eventOptions')) {
            // push to datalayer

            let pushObject = {
                'event': 'Video Event',
                'event_name': event.data.eventName,
                [event.data.eventName]: event.data.eventOptions
            }

            console.log('[playerEventsToDataLayer] pushing', pushObject);

            // window.dataLayer = 'NOPO';
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(pushObject);
        }

    }

});



// WEBPACK FOOTER //
// ./src/scripts/playerEventsToDataLayer.js